import debounce from 'lodash/debounce';
import { useMemo, useState } from 'react';
import { TextField } from 'src/components/TextField';

interface TextFilterConfig {
  label: string;
  value: any;
  setValue: (newVal: any, close?: boolean) => void;
  valueOnly?: boolean;
  disabled?: boolean;
  onChange?: (newVal: any) => void;
  debounceDuration?: number;
}

export const NumberFilter: React.FC<TextFilterConfig> = ({
  label,
  value,
  setValue,
  valueOnly,
  disabled,
  onChange,
  debounceDuration = 500,
}) => {
  const [localValue, setLocalValue] = useState(value);

  const debouncedSetValue = useMemo(() => {
    return debounce((newVal, close) => {
      setValue(newVal, close);
      onChange && onChange?.(newVal);
    }, debounceDuration);
  }, [debounceDuration, onChange, setValue]);

  if (valueOnly) {
    return value;
  }

  return (
    <>
      <TextField
        label={label}
        onChange={(e) => {
          setLocalValue(e.target.value);
          debouncedSetValue(e.target.value, false);
        }}
        value={localValue || ''}
        disabled={disabled}
        type="number"
      />
    </>
  );
};
